import { reduxForm } from 'redux-form';
import { SubmitButtonConnected } from './container';
import { SubmitButtonProps } from './SubmitButton.types';
import { spaPackageFormConfig } from '../shared';

export const SubmitButton: any = reduxForm<{}, SubmitButtonProps>(spaPackageFormConfig)(
  SubmitButtonConnected as any
);
